<template>
    <span class="booking-guarantee hidden-print" @click="openDialog" @keydown.enter="openDialog" tabindex="0" role="button" :aria-label="$t('VoucherProtection.header')">
        <slot>
            <IconSvg filepath="protection.svg" />
            {{ $t('VoucherProtection.button') }}
        </slot>

        <Modal v-if="showModal" @close="closeDialog" closeOnEscape dismissible hide-footer class="protection-modal">
            <div class="d-flex flex-column flex-lg-row">
                <div class="image-wrapper">
                    <img
                        src="@/assets/Shield_w_Background_2x.png"
                        alt="Animod gutscheinshchutz"
                        class="protection-image"
                    />
                </div>
                <div class="protection-text">
                    <h3 class="mb-lg-3">{{ $t('VoucherProtection.header') }}</h3>
                    <p>
                        {{ $t('VoucherProtection.text1') }}
                    </p>

                    <translate path="VoucherProtection.text2" tag="p" :params="{ date: '01.05.2019' }">
                        <a slot="phone" :href="'tel:' + supportPhoneNumber"
                            ><strong>{{ supportPhoneNumber }}</strong></a
                        >
                        <a slot="email" :href="'mailto:' + $t('Contact.email')"
                            ><strong>{{ $t('Contact.email') }}</strong></a
                        >
                    </translate>

                    <button class="btn btn-primary align-self-end text-uppercase" @click="closeDialog">
                        {{ $t('Generic.close') }}
                    </button>
                </div>
            </div>
        </Modal>
    </span>
</template>

<script>
import Modal from '@/components/Modal';

export default {
    name: 'VoucherProtection',
    components: {
        Modal
    },
    data() {
        return {
            showModal: false
        };
    },
    props: {},
    computed: {
        supportPhoneNumber() {
            return this.$store.state.globalMeta.supportPhoneNumber;
        }
    },
    methods: {
        openDialog() {
            this.showModal = true;
        },
        closeDialog() {
            this.showModal = false;
        }
    }
};
</script>

<style scoped lang="scss">
@use '@/styles/variables';
@use '@/styles/mixins';

span.booking-guarantee {
    color: var(--primary);
    display: flex;
    justify-content: center;
    align-items: center;

    &:not(:hover) {
        opacity: 0.8 !important;
    }

    .icon-protection {
        margin-right: 5px;
    }
}

.protection-modal {
    ::v-deep .modal-body {
        padding: 0 !important;
    }

    .protection-image {
        width: 300px;
        flex: 1 0 300px;
    }

    .protection-text {
        padding: 30px;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .image-wrapper {
        text-align: center;
        background: linear-gradient(90deg, hsla(168, 61%, 41%, 1), hsl(134, 61%, 41%));
    }

    @include mixins.mobile-only {
        .protection-image {
            width: 50px;
        }

        .protection-text {
            padding: variables.$grid-padding;
        }
    }
}
</style>
